import React from 'react';

interface ErrorDisplayProps {
  error: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error }) => {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ 
      backgroundColor: '#293A41',
      backgroundImage: 'url(/background.jpg)',
      backgroundPosition: 'bottom',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundAttachment: 'fixed'
    }}>
      <div className="text-center max-w-md mx-auto px-6" style={{ opacity: 1 }}>
        {/* Error icon */}
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 15.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold mb-4" style={{ color: '#4B5563' }}>Oops! Something went wrong</h2>
        {/* Error message with context-specific text */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <p className="text-red-800 font-medium">
            {error === 'CONTAINER_NOT_FOUND' 
              ? 'The storage container could not be found or accessed.' 
              : error}
          </p>
        </div>
        {/* Retry button to reload the page */}
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center px-6 py-3 text-sm font-medium text-white rounded-lg transition-all duration-200"
          style={{ backgroundColor: '#F96423' }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e55a1f'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#F96423'}
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorDisplay;
